import type { AuthTokens } from '@/types/auth.types'

const TOKEN_KEY = 'access_token'
const REFRESH_TOKEN_KEY = 'refresh_token'
const AUTH_METHOD_KEY = 'auth_method'

export type AuthMethod = 'own' | 'entra'

export const tokenManager = {
  // ── JWT propio ────────────────────────────────────────────────────────────

  getToken(): string | null {
    return localStorage.getItem(TOKEN_KEY)
  },

  getRefreshToken(): string | null {
    return localStorage.getItem(REFRESH_TOKEN_KEY)
  },

  setTokens(tokens: AuthTokens): void {
    localStorage.setItem(TOKEN_KEY, tokens.token)
    localStorage.setItem(REFRESH_TOKEN_KEY, tokens.refresh_token)
  },

  clearTokens(): void {
    localStorage.removeItem(TOKEN_KEY)
    localStorage.removeItem(REFRESH_TOKEN_KEY)
  },

  // ── Método de autenticación activo ────────────────────────────────────────

  getAuthMethod(): AuthMethod | null {
    return localStorage.getItem(AUTH_METHOD_KEY) as AuthMethod | null
  },

  setAuthMethod(method: AuthMethod): void {
    localStorage.setItem(AUTH_METHOD_KEY, method)
  },

  clearAuthMethod(): void {
    localStorage.removeItem(AUTH_METHOD_KEY)
  },

  // ── Estado general ────────────────────────────────────────────────────────

  isAuthenticated(): boolean {
    const method = this.getAuthMethod()
    if (method === 'entra') {
      // Para Entra ID la sesión la gestiona MSAL; aquí solo indicamos que el
      // método está activo. La verificación real ocurre en AuthProvider.
      return true
    }
    return !!this.getToken()
  },

  clearAll(): void {
    this.clearTokens()
    this.clearAuthMethod()
  },

  // ── Helpers JWT propio ────────────────────────────────────────────────────

  isTokenExpired(token: string): boolean {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]))
      const currentTime = Math.floor(Date.now() / 1000)
      return payload.exp < currentTime
    } catch {
      return true
    }
  },

  shouldRefreshToken(): boolean {
    if (this.getAuthMethod() === 'entra') {
      // MSAL gestiona su propio refresh; no aplica para este mecanismo.
      return false
    }

    const token = this.getToken()
    const refreshToken = this.getRefreshToken()

    if (!token || !refreshToken) {
      return false
    }

    try {
      const payload = JSON.parse(atob(token.split('.')[1]))
      const currentTime = Math.floor(Date.now() / 1000)
      const fiveMinutesFromNow = currentTime + 300
      return payload.exp < fiveMinutesFromNow
    } catch {
      return true
    }
  }
}
